import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { Parent } from './Parent.js';
import './styles.css';

// One deployment, two doors. The parent console is a separate path rather than a
// mode inside the studio, so a child cannot stumble into it from their own UI.
const isParent = window.location.pathname.startsWith('/parent');

createRoot(document.getElementById('root')!).render(
  <StrictMode>{isParent ? <Parent /> : <App />}</StrictMode>,
);
